// ResizableDivider component for creating draggable panel dividers
import React from 'react';

const ResizableDivider = ({ index, isDragging, dragIndex, onMouseDown }) => {
    const isCurrentlyDragging = isDragging && dragIndex === index;

    const handleMouseDown = (e) => {
        onMouseDown(index, e);
    };

    return (
        <div
            className={`resize-divider resize-divider-vertical ${isCurrentlyDragging ? 'dragging' : ''}`}
            onMouseDown={handleMouseDown}
            style={{
                backgroundColor: isCurrentlyDragging ? '#3b82f6' : '#d1d5db'
            }}
        />
    );
};

export default ResizableDivider;